import { render, staticRenderFns } from "./SuiviPathologie.vue?vue&type=template&id=2c18a9f5&scoped=true"
import script from "./SuiviPathologie.vue?vue&type=script&lang=js"
export * from "./SuiviPathologie.vue?vue&type=script&lang=js"
import style0 from "./SuiviPathologie.vue?vue&type=style&index=0&id=2c18a9f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18a9f5",
  null
  
)

export default component.exports